import { render, staticRenderFns } from "./PersonalEducation.vue?vue&type=template&id=9df29898&"
import script from "./PersonalEducation.vue?vue&type=script&lang=js&"
export * from "./PersonalEducation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalEducation.vue"
export default component.exports